import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, LogOut, LayoutDashboard, Shield } from "lucide-react";
import { Logo } from "@/components/brand";
import { useAuth } from "@/context/AuthContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function TopBar({ brandBg }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div style={{ position: "sticky", top: 0, zIndex: 40, background: "rgba(7,8,15,.85)", backdropFilter: "blur(12px)", borderBottom: "1px solid var(--border)" }}>
      <div className="container-x" style={{ padding: "12px 0", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div onClick={() => nav("/")} style={{ cursor: "pointer" }} data-testid="logo-home"><Logo brandBg={brandBg} /></div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="avatar-menu" className="focus-ring" style={{ width: 34, height: 34, borderRadius: 999, background: "var(--raised)", border: "1px solid var(--border-strong)", color: "var(--text)", cursor: "pointer", fontWeight: 500 }}>
                  {(user.name || "?")[0]?.toUpperCase()}
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="bg-clip-raised border-clip text-clip-text" style={{ background: "var(--raised)", border: "1px solid var(--border-strong)", color: "var(--text)" }}>
                <DropdownMenuItem data-testid="menu-dashboard" onClick={() => nav(user.role === "admin" ? "/admin" : "/dashboard")}>
                  <LayoutDashboard size={14} className="mr-2" /> Dashboard
                </DropdownMenuItem>
                {user.role === "admin" && (
                  <DropdownMenuItem onClick={() => nav("/admin")}><Shield size={14} className="mr-2" /> Admin</DropdownMenuItem>
                )}
                <DropdownMenuItem data-testid="menu-logout" onClick={async () => { await logout(); nav("/"); }}>
                  <LogOut size={14} className="mr-2" /> Log out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <button className="focus-ring" onClick={() => nav("/admin/login")} data-testid="admin-login-link" style={{ background: "none", border: "none", color: "var(--sub)", fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}>
                <Lock size={13} /> Admin log in
              </button>
              <button className="btn-outline focus-ring" onClick={() => nav("/login")} data-testid="login-btn" style={{ padding: "8px 14px", fontSize: 13 }}>Log in</button>
              <button className="btn-brand focus-ring" onClick={() => nav("/signup")} data-testid="start-clipping-btn" style={{ padding: "8px 16px", fontSize: 13 }}>Start clipping</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
